
import { Spinner } from "react-bootstrap";
import TableComponent from "../../../components/dashboard/table";

interface IndicatorsTableProps {
    loading: boolean;
    ifozHistoric: any[];
    iapHistoric: any[];
    iepHistoric: any[];
    ifczHistoric: any[];
    hasFilter: boolean;
    companyCreatedAt?: string | null;
}

/**
 * Component to display the indicators table.
 */
const IndicatorsTable = ({ loading, ifozHistoric, iapHistoric, iepHistoric, ifczHistoric, hasFilter, companyCreatedAt }: IndicatorsTableProps) => {
    return (
        <div style={{ padding: '2em 0 1em 0', width: '100%' }}>
            {loading ? (
                <div className="d-flex align-items-center justify-content-center w-100" style={{ minHeight: '300px', width: '100%' }}>
                    <Spinner style={{ color: '#c9c9c9' }} />
                </div>
            ) : (
                <TableComponent 
                    ifozHistoric={ifozHistoric} 
                    ipaHistoric={iapHistoric} 
                    iepHistoric={iepHistoric} 
                    ifczHistoric={ifczHistoric} 
                    hasFilter={hasFilter}
                    companyCreatedAt={companyCreatedAt}
                />
            )}
        </div>
    );
};

export default IndicatorsTable;
